function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  "data-figma-bg-blur-radius": 13,
  d: "M63.8601 35.43C63.8601 51.1319 51.1319 63.8601 35.43 63.8601C19.7281 63.8601 7 51.1319 7 35.43C7 19.731 19.7281 7 35.43 7C51.1319 7 63.8601 19.731 63.8601 35.43Z",
  fill: "url(#paint0_linear_531_2264)"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5,
  filter: "url(#filter1_f_531_2264)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M53.6481 35.4032C53.6481 45.4011 45.5437 53.5056 35.5457 53.5056C25.5478 53.5056 17.4434 45.4011 17.4434 35.4032C17.4434 25.407 25.5478 17.3008 35.5457 17.3008C45.5437 17.3008 53.6481 25.407 53.6481 35.4032Z",
  fill: "#CFB4B4"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  "data-figma-bg-blur-radius": 24,
  d: "M74.8601 46.43C74.8601 62.1319 62.1319 74.8601 46.43 74.8601C30.7281 74.8601 18 62.1319 18 46.43C18 30.731 30.7281 18 46.43 18C62.1319 18 74.8601 30.731 74.8601 46.43Z",
  fill: "url(#paint1_linear_531_2264)"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_d_531_2264)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55.4884 37C51.407 37 49.1733 39.1555 47.3256 41.05C45.4778 39.1555 43.2442 37 39.1628 37C33.7204 37 31 41.6065 31 46.45C31 54.6055 40.5238 61.3 47.3256 64C54.1274 61.3 63.6512 54.6055 63.6512 46.45C63.6512 41.6065 60.9307 37 55.4884 37Z",
  fill: "url(#paint2_linear_531_2264)"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.9,
  d: "M46.4635 58H49V44H46.4635L44 45.575V48.4917L46.4635 46.8778V58Z",
  fill: "#FF7474"
});

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "bgblur_0_531_2264_clip_path",
  transform: "translate(6 6)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M63.8601 35.43C63.8601 51.1319 51.1319 63.8601 35.43 63.8601C19.7281 63.8601 7 51.1319 7 35.43C7 19.731 19.7281 7 35.43 7C51.1319 7 63.8601 19.731 63.8601 35.43Z"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_f_531_2264",
  x: 0.443359,
  y: 0.300781,
  width: 70.2051,
  height: 70.2046,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8.5,
  result: "effect1_foregroundBlur_531_2264"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "bgblur_1_531_2264_clip_path",
  transform: "translate(6 6)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M74.8601 46.43C74.8601 62.1319 62.1319 74.8601 46.43 74.8601C30.7281 74.8601 18 62.1319 18 46.43C18 30.731 30.7281 18 46.43 18C62.1319 18 74.8601 30.731 74.8601 46.43Z"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_d_531_2264",
  x: 27,
  y: 37,
  width: 40.6514,
  height: 35,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.14 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_531_2264"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_531_2264",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_531_2264",
  x1: 39.616,
  y1: 39.2376,
  x2: -10.3463,
  y2: 63.5304,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF7474"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF7474"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_531_2264",
  x1: 17.8601,
  y1: 20.36,
  x2: 71.3601,
  y2: 74.86,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF7474"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DE4A60"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_531_2264",
  x1: 46,
  y1: 51,
  x2: 27,
  y2: 40,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0552524,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.68
})));

function SvgPlayAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -6,
    y: -6,
    width: 82.8604,
    height: 82.8599
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6.5px)",
      clipPath: "url(#bgblur_0_531_2264_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _ref2, _ref3, /*#__PURE__*/React.createElement("foreignObject", {
    x: -6,
    y: -6,
    width: 104.86,
    height: 104.86
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(12px)",
      clipPath: "url(#bgblur_1_531_2264_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayAlt);
export default __webpack_public_path__ + "assets/media/PlayAlt.9c2ace35.svg";
export { ForwardRef as ReactComponent };